import { useEffect } from "react";
import Pages from "./routes";

const App = () => {
  // Once the app has been running fine for a bit, clear the ChunkLoadError
  // reload guard (see WithSuspense) so a later chunk error — e.g. from
  // another deploy landing while this tab stays open — can still trigger one
  // more self-healing reload instead of silently falling through to the
  // error screen for the rest of the session.
  useEffect(() => {
    const timer = setTimeout(() => {
      sessionStorage.removeItem("chunk-load-reload-attempted");
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  return <Pages />;
};

export default App;
